import i18n from "../../main"
export function getList() {
  var title = i18n.t('test')
  console.log('navbar getList==', title)
  var list = [
    // {
    //   title: i18n.t("首页"),
    //   path: "/",
    //   power: 1,
    //   children: [],
    // },
    {
      title: i18n.t("关于我们"),
      path: "/About",
      power: 1,
      children: [
        {
          title: i18n.t("公司简介"),
          img: require("../../../static/img/bar_1.png"),
          blue_img: require("../../../static/img/bar_1.png"),
          path: "/About",
          children: [],
          tag: 'CompanyProfile'
        },
        {
          title: i18n.t("组织架构"),
          img: require("../../../static/img/bar_2.png"),
          blue_img: require("../../../static/img/bar_2.png"),
          path: "/About",
          children: [],
          tag: 'OrganizationalStructure'
        },
        {
          title: i18n.t("我们的部门"),
          img: require("../../../static/img/bar_3.png"),
          blue_img: require("../../../static/img/bar_3.png"),
          path: "/About",
          children: [],
          tag: 'OurDepartment'
        },
        {
          title: i18n.t("发展历程"),
          img: require("../../../static/img/bar_4.png"),
          blue_img: require("../../../static/img/bar_4.png"),
          path: "/About",
          children: [],
          tag: 'Milestone'
        },
        {
          title: i18n.t("荣誉资质"),
          img: require("../../../static/img/bar_5.png"),
          blue_img: require("../../../static/img/bar_5.png"),
          path: "/About",
          children: [],
          tag: 'CertificatesAndHonors'
        },
      ],
    },
    {
      title: i18n.t("解决方案"),
      path: "/SolutionFTTx",
      power: 1,
      children: [
        {
          title: i18n.t("FTTx"),
          img: require("../../../static/img/bar_1.png"),
          blue_img: require("../../../static/img/bar_1.png"),
          path: "/SolutionFTTx", children: [], tag: 'FTTx'
        },
        {
          title: i18n.t("Data Center"),
          img: require("../../../static/img/bar_2.png"),
          blue_img: require("../../../static/img/bar_2.png"),
          path: "/SolutionDataCenter", children: [], tag: 'DataCenter'
        },
        {
          title: i18n.t("Customized"),
          img: require("../../../static/img/bar_3.png"),
          blue_img: require("../../../static/img/bar_3.png"),
          path: "/SolutionCustomized", children: [], tag: 'Customized'
        },
      ],
    },
    {
      title: i18n.t("产品中心"),
      path: "/Products",
      power: 1,
      children: [
        {
          title: i18n.t("光纤连接器"),
          img: require("../../../static/img/bar_5.png"),
          blue_img: require("../../../static/img/bar_5.png"),
          path: "/Products", children: [], tag: 'Connector'
        },
        {
          title: i18n.t("光纤适配器"),
          img: require("../../../static/img/bar_6.png"),
          blue_img: require("../../../static/img/bar_6.png"),
          path: "/Products", children: [], tag: 'Adapter'
        },
        {
          title: i18n.t("光纤衰减器"),
          img: require("../../../static/img/bar_7.png"),
          blue_img: require("../../../static/img/bar_7.png"),
          path: "/Products", children: [], tag: 'Attenuator'
        },
        {
          title: i18n.t("光纤配线架"),
          img: require("../../../static/img/bar_8.png"),
          blue_img: require("../../../static/img/bar_8.png"),
          path: "/Products", children: [], tag: 'ODF'
        },
        {
          title: i18n.t("其他产品"),
          img: require("../../../static/img/bar_9.png"),
          blue_img: require("../../../static/img/bar_9.png"),
          path: "/Products", children: [], tag: 'Others'
        },
      ],
    },
    {
      title: i18n.t("新闻资讯"),
      path: "/News",
      power: 1,
      children: [
        {
          title: i18n.t("公司新闻"),
          img: require("../../../static/img/bar_4.png"),
          blue_img: require("../../../static/img/bar_4.png"),
          path: "/News", children: [], tag: '1'
        },
        {
          title: i18n.t("行业新闻"),
          img: require("../../../static/img/bar_5.png"),
          blue_img: require("../../../static/img/bar_5.png"),
          path: "/News", children: [], tag: '2'
        },
      ],
    },
    {
      title: i18n.t("联系我们"),
      path: "/CallUs",
      power: 1,
      children: [],
    },
  ];
  return list
}
